<dx-chart
    *ngIf="!!conveyanceChartData"
    [palette]="conveyanceChartPalette || palette"
    [paletteExtensionMode]="paletteMode"
    [dataSource]="conveyanceChartData"
    class="cc-white-background"
>
    <dxo-title [text]="conveyanceChartTitle">
        <dxo-font [size]="14" [weight]="600"></dxo-font>
        <dxo-margin [top]="5" [bottom]="0" [left]="0" [right]="0"></dxo-margin>
        <dxo-subtitle [text]="conveyanceChartSubTitle">
            <dxo-font [size]="14" [weight]="600"></dxo-font>
        </dxo-subtitle>
    </dxo-title>
    <dxo-loading-indicator [enabled]="false"></dxo-loading-indicator>
    <dxo-legend
        horizontalAlignment="right"
        verticalAlignment="top"
        orientation="vertical"
        [columnItemSpacing]="5"
        [rowItemSpacing]="1"
    >
        <dxo-font [size]="fontSize"></dxo-font>
    </dxo-legend>
    <dxo-size [width]="width" [height]="height"></dxo-size>
    <dxi-series
        valueField="homwOwnerToHomeOwner"
        name="Homeowner To Homeowner"
        *ngIf="isHomwOwnerToHomeOwner"
    ></dxi-series>
    <dxi-series
        valueField="homwOwnerToDeclarant"
        name="Homeowner To Declarant"
        *ngIf="isHomwOwnerToDeclarant"
    ></dxi-series>
    <dxi-series valueField="homwOwnerToBuilder" name="Homeowner To Builder" *ngIf="isHomwOwnerToBuilder"></dxi-series>
    <dxi-series
        valueField="declarantToDeclarant"
        name="Declarant To Declarant"
        *ngIf="isDeclarantToDeclarant"
    ></dxi-series>
    <dxi-series
        valueField="declarantToHomeOwner"
        name="Declarant To Homeowner"
        *ngIf="isDeclarantToHomeOwner"
    ></dxi-series>
    <dxi-series valueField="declarantToBuilder" name="Declarant To Builder" *ngIf="isDeclarantToBuilder"></dxi-series>
    <dxi-series valueField="builderToBuilder" name="Builder To Builder" *ngIf="isBuilderToBuilder"></dxi-series>
    <dxi-series valueField="builderToHomeOwner" name="Builder To Homeowner" *ngIf="isBuilderToHomeOwner"></dxi-series>
    <dxi-series valueField="builderToDeclarant" name="Builder To Declarant" *ngIf="isBuilderToDeclarant"></dxi-series>
    <dxo-common-series-settings argumentField="period" type="stackedBar"></dxo-common-series-settings>
    <dxo-export [enabled]="!widgetMode" [fileName]="exportFileName()"></dxo-export>
</dx-chart>
